import { CalendarPlus, ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { downloadIcs, googleCalendarUrl } from "@/lib/ics";
import { cn } from "@/lib/utils";

const TONE = {
  dark: "border border-paper/35 bg-ink/35 text-paper backdrop-blur-md hover:bg-paper hover:text-ink",
  light: "border border-border bg-background text-foreground hover:bg-secondary",
};

/** «Legg i kalender» as a small menu: Google Kalender opens in a tab, Apple/Outlook get an .ics file. */
export const AddToCalendar = ({ ev, tone = "light", className, testId = "add-to-calendar" }) => {
  const opts = { url: typeof window !== "undefined" ? window.location.href : "", location: ev.location ? `${ev.location}, Halsnøy Kulturhus` : "Halsnøy Kulturhus" };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" className={cn("inline-flex h-12 items-center gap-2 rounded-full px-5 text-[14.5px] font-medium transition-[background-color,color,transform] duration-300 hover:scale-[1.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sol", TONE[tone], className)} data-testid={`${testId}-button`}>
          <CalendarPlus className="h-4 w-4" /> <span className="whitespace-nowrap"><span className="sm:hidden">Kalender</span><span className="hidden sm:inline">Legg i kalender</span></span> <ChevronDown className="h-3.5 w-3.5 opacity-70" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[220px]" data-testid={`${testId}-menu`}>
        <DropdownMenuItem asChild><a href={googleCalendarUrl(ev, opts)} target="_blank" rel="noopener noreferrer" data-testid={`${testId}-google`}>Google Kalender</a></DropdownMenuItem>
        <DropdownMenuItem onSelect={() => downloadIcs(ev, opts)} data-testid={`${testId}-ics`}>Apple, Outlook m.fl. (.ics)</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
